// extracted by mini-css-extract-plugin
export default {"listContainer":"RecordList_listContainer__WOsGs","recordList":"RecordList_recordList__E9HAe"};